import { render, staticRenderFns } from "./MultiSelectDropdown.vue?vue&type=template&id=2fc2620a&scoped=true&"
import script from "./MultiSelectDropdown.vue?vue&type=script&lang=js&"
export * from "./MultiSelectDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectDropdown.vue?vue&type=style&index=0&id=2fc2620a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc2620a",
  null
  
)

export default component.exports